import { Box, Card, CardContent, Typography, Grid, Stack, Divider } from "@mui/material";

export default function DashboardDiario({ state }) {
  const hoyInicio = new Date();
  hoyInicio.setHours(0, 0, 0, 0);

  const hoyFin = new Date();
  hoyFin.setHours(23, 59, 59, 999);

  const inicio = hoyInicio.toISOString();
  const fin = hoyFin.toISOString();

  const ventasHoy = state.filtrarVentas(inicio, fin);
  const totalHoy = state.totalVendido(inicio, fin);
  const cantidadVentas = ventasHoy.length;
  const ticketPromedio = state.ticketPromedio(inicio, fin);

  const topProductos = state.topProductos(inicio, fin).slice(0, 3);

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Resumen de Hoy
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={3}>
        {new Date().toLocaleDateString()}
      </Typography>

      <Grid container spacing={3}>
        {/* TOTAL VENDIDO */}
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: "#e8f5e9" }}>
            <CardContent>
              <Typography variant="subtitle2">Total Vendido</Typography>
              <Typography variant="h4" fontWeight="bold">
                {state.config.moneda} {totalHoy.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* CANTIDAD DE VENTAS */}
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: "#e3f2fd" }}>
            <CardContent>
              <Typography variant="subtitle2">Ventas Realizadas</Typography>
              <Typography variant="h4" fontWeight="bold">
                {cantidadVentas}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* TICKET PROMEDIO */}
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: "#fff3e0" }}>
            <CardContent>
              <Typography variant="subtitle2">Ticket Promedio</Typography>
              <Typography variant="h4" fontWeight="bold">
                {state.config.moneda} {ticketPromedio.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* TOP PRODUCTOS */}
      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Top Productos de Hoy
          </Typography>

          {topProductos.length === 0 && (
            <Typography color="text.secondary">
              No hay ventas registradas hoy
            </Typography>
          )}

          <Stack spacing={1}>
            {topProductos.map((p, i) => (
              <Box key={i} display="flex" justifyContent="space-between">
                <Typography>
                  {i + 1}. {p.nombre}
                </Typography>
                <Typography fontWeight="bold">
                  {p.cantidad} uds
                </Typography>
              </Box>
            ))}
          </Stack>

          <Divider sx={{ mt: 2 }} />

          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            textAlign="center"
            mt={2}
          >
            Datos calculados automáticamente desde ventas
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
